import { ref, computed } from 'vue';

import { useStore } from '@/store';

export const useAdvertisement = (advertisementName, image) => {
  const adImage = image;
  const store = useStore();

  const isAdvertisementLoading = ref(true);
  const advertisement = computed(() => store.getters['auth/getAdvertisement'] || {});

  const hasSomeAdvertisement = ref(false);

  const loadImage = async () => {
    const advertisementImageLoading = new Promise((resolve, reject) => {
      if (adImage.value) adImage.value.onload = () => resolve();
      if (!hasSomeAdvertisement.value) reject();
    });

    await advertisementImageLoading;
    isAdvertisementLoading.value = false;
  };

  const fetchAdvertisement = async () => {
    await store.dispatch('auth/fetchAdvertisement', advertisementName).finally(async () => {
      hasSomeAdvertisement.value = Object.keys(advertisement.value).length > 0;
      if (hasSomeAdvertisement.value) await loadImage();
      else isAdvertisementLoading.value = false;
    });
  };

  const handleAvertisementClick = () => {
    let url = advertisement.value.redirectUrl;
    const pattern = /^((http|https|ftp):\/\/)/;

    if (!pattern.test(url)) {
      url = `http://${url}`;
    }
    window.open(url, '_blank').focus();
  };

  return {
    isAdvertisementLoading,
    advertisement,
    adImage,
    hasSomeAdvertisement,
    handleAvertisementClick,
    fetchAdvertisement,
  };
};
